<div
  class="row w-100 d-flex justify-content-between"
  [ngClass]="{ 'p-3': isMobile }"
  *ngIf="diet"
>
  <div class="d-flex flex-column col-12 col-lg-4">
    <div class="d-flex col-12">
      <h6>Fechas: &nbsp;</h6>
      <span>{{ diet.parsedStartAt }}</span>
      <span>&nbsp; - &nbsp;</span>
      <span class="me-3">{{ diet.parsedFinishAt }}</span>
    </div>

    <div class="d-flex col-12">
      <h6>Estado: &nbsp;</h6>
      <span *ngIf="diet.finished">Finalizada</span>
      <span *ngIf="!diet.finished">En progreso</span>
    </div>

    <div class="d-flex col-12">
      <h6 class="me-1">Cantidad de agua: &nbsp;</h6>
      <span *ngIf="diet.water">{{ diet.water }} Lts.</span>
      <span *ngIf="!diet.water">Sin información</span>
    </div>

    <div class="d-flex col-12">
      <h6>Creado por: &nbsp;</h6>
      <span>{{ diet.trainerUserName }} {{ diet.trainerUserLastName }}</span>
    </div>

    <div class="d-flex col-12">
      <h6 class="me-1">Días: &nbsp;</h6>
      <span *ngIf="diet.daysOfWeek && diet.daysOfWeek.length > 0">{{
        translateDaysOfWeek(diet.daysOfWeek)
      }}</span>
      <span *ngIf="!diet.daysOfWeek || diet.daysOfWeek.length === 0"
        >Todos los días</span
      >
    </div>

    <div class="d-flex col-12">
      <h6 class="me-1">Descripción: &nbsp;</h6>
      <span>{{ diet.description }}</span>
    </div>
  </div>

  <div class="col-12 col-lg-6">
    <div class="d-flex justify-content-lg-end justify-content-center">
      <button
        class="btn-custom mb-3 me-1"
        (click)="openCalendarModal(diet)"
        *ngIf="!isMobile"
      >
        Calendario
      </button>
      <button
        class="btn-custom-outline mb-3 me-1 d-flex align-items-center justify-content-center"
        style="height: 2rem; width: 200px"
        (click)="getDietProgretion(diet)"
        *ngIf="!isMobile"
      >
        <div
          *ngIf="diet.loading"
          class="spinner-border"
          style="font-size: 0.8rem; width: 20px; height: 20px"
          role="status"
        >
          <span class="visually-hidden">Loading...</span>
        </div>
        <span *ngIf="!diet.loading">Progresiones</span>
      </button>
      <button
        class="btn btn-danger mx-lg-2 d-flex align-items-center justify-content-center"
        style="height: 2rem; width: 200px"
        *ngIf="diet.status !== 'FINISHED'"
        (click)="finishDiet(diet.id)"
      >
        <span *ngIf="diet.status == 'CREATED' || diet.status == 'NOT_STARTED'"
          >Eliminar</span
        >
        <span *ngIf="diet.status !== 'CREATED' && diet.status !== 'NOT_STARTED'"
          >Finalizar</span
        >
      </button>
    </div>

    <div class="w-100 text-center">
      <span class="fw-bold fs-3 w-100">Total Dieta</span>
    </div>
    <div
      class="d-flex flex-column flex-lg-row align-items-lg-end align-items-center justify-content-lg-end justify-content-center"
    >
      <div
        class="d-flex justify-content-center align-items-center me-lg-2"
        style="height: 100px; width: 100px"
      >
        <canvas
          baseChart
          class="p-2"
          [datasets]="datasets"
          [labels]="labels"
          [options]="options"
          [legend]="false"
          [plugins]="plugins"
          [type]="'pie'"
        ></canvas>
      </div>

      <app-macros-list [macros]="diet.macros"></app-macros-list>
    </div>
  </div>

  <div
    class="d-flex flex-column flex-lg-row justify-content-between row gx-lg-3 w-100"
  >
    <div class="col-lg-6 col-12">
      <span class="fs-3 fw-bold">Comidas</span>

      <div
        class="col-12 d-flex justify-content-between my-2 p-2 meal-card d-flex flex-column flex-lg-row"
        [ngClass]="{ 'selected-meal-card': meal.selected }"
        *ngFor="let meal of diet.meals"
        (click)="toggleEditing(meal)"
      >
        <div class="">
          <div class="d-flex align-items-end">
            <span class="fw-bold fs-5">{{ meal.order }}. {{ meal.title }}</span>
          </div>
        </div>

        <div class="d-flex justify-content-around">
          <div
            class="d-flex flex-column justify-content-center align-items-center mx-1 text-center"
          >
            <span class="fw-bold">kcal</span>
            <span>{{ meal.macros?.kcal! | truncate }}kcal</span>
          </div>

          <div
            class="d-flex flex-column justify-content-center align-items-center mx-1"
          >
            <span class="fw-bold">Proteínas</span>
            <span>{{ meal.macros?.proteins! | truncate }}gr</span>
          </div>
        </div>

        <div class="d-flex justify-content-around">
          <div
            class="d-flex flex-column justify-content-center align-items-center mx-1"
          >
            <span class="fw-bold">Carbohidratos</span>
            <span>{{ meal.macros?.carbohydrates! | truncate }} gr</span>
          </div>

          <div
            class="d-flex flex-column justify-content-center align-items-center mx-1 text-center"
          >
            <span class="fw-bold">Grasas</span>
            <span>{{ meal.macros?.fats! | truncate }} gr</span>
          </div>
        </div>
      </div>

      <div
        class="w-100 border p-3 my-3 rounded-2 text-center"
        *ngIf="!diet.meals"
      >
        <span class="p-3 fs-5 text-center"> No hay comidas</span>
      </div>
      <button
        class="food-create-btn"
        *ngIf="diet.status !== 'FINISHED'"
        (click)="toggleEditing(undefined)"
      >
        +
      </button>

      <button
        class="food-option-create-btn my-2"
        *ngIf="diet.status !== 'FINISHED' && !isMobile"
        (click)="openImportUserSelectorModal()"
      >
        Importar
      </button>
    </div>
    <div class="col-12 col-lg-6 translucent-bg p-3 mt-3 mt-lg-0">
      <div
        class="d-flex h-100 w-100 justify-content-center align-items-center text-center"
        style="min-height: 400px"
        *ngIf="mealMode === 'watching'"
      >
        <span class="fs-2 fw-bold">NO HAY COMIDA SELECCIONADA</span>
      </div>

      <div *ngIf="mealMode !== 'watching'">
        <div
          class="d-flex p-1 align-items-center"
          style="color: rgb(175, 175, 175); cursor: pointer"
          (click)="cancelForm()"
        >
          <i class="bi bi-caret-left-fill"></i>
          <span *ngIf="mealMode == 'editing'">Cancelar Edición de comida</span>
          <span *ngIf="mealMode == 'creating'"
            >Cancelar creación de comida</span
          >
        </div>

        <form [formGroup]="mealForm" (ngSubmit)="manageMealSubmit()">
          <div class="form-floating mb-3">
            <input
              class="form-control"
              type="text"
              [ngClass]="{
                'is-invalid': title.invalid && title.touched
              }"
              placeholder="Título"
              formControlName="title"
            />

            <label for="">Título</label>

            <div *ngIf="title.invalid && title.touched" class="text-danger">
              Ingrese un nombre.
            </div>
          </div>

          <div class="" *ngIf="mealToEdit">
            <span class="fs-4 fw-bold">Alimentos</span>

            <div
              class="w-100 border rounded-2 text-center"
              *ngIf="!mealToEdit!.foodOptions"
            >
              <span class="p-3 fs-5 text-center"> No hay alimentos </span>
            </div>

            <div
              *ngFor="
                let foodOptionGroup of mealToEdit!.foodOptions;
                let index = index
              "
              class="rounded px-1 mt-2 d-flex flex-column"
            >
              <!-- <span class="m-1 fw-bold"
                            >Comida {{ index + 1 }}</span
                          > -->

              <div
                class="border rounded p-1 mt-2 d-flex align-items-center justify-content-between w-100 flex-column flex-lg-row"
                [ngClass]="{ selected: foodOption.isDefault }"
                style="cursor: pointer"
                (click)="setDefaultFoodOption(foodOption, foodOptionGroup)"
                *ngFor="let foodOption of foodOptionGroup"
              >
                <div class="d-flex flex-column">
                  <span
                    class="supplement-tag"
                    *ngIf="foodOption.food.type === 'SUPPLEMENT'"
                    >Suplemento</span
                  >
                  <span class="default-text" *ngIf="foodOption.isDefault"
                    >Predeterminada</span
                  >
                  <span class="fw-bold">
                    {{ foodOption.food?.name }}
                  </span>

                  <label
                    *ngIf="foodOption.food!.portionMeasure == '100GR'"
                    style="color: rgb(175, 175, 175)"
                    >{{ foodOption.portion }} gr</label
                  >
                  <label
                    *ngIf="foodOption.food!.portionMeasure == 'UNIT'"
                    for=""
                    >{{ foodOption.portion }} Unidad/es</label
                  >
                  <label
                    *ngIf="foodOption.food!.portionMeasure == 'SPOON'"
                    for=""
                    >{{ foodOption.portion }} Cucharada/as</label
                  >
                </div>

                <div class="d-flex">
                  <div
                    class="d-flex flex-column justify-content-center align-items-center mx-1"
                  >
                    <span class="fs-6" class="fw-bold">kcal</span>
                    <span>{{ foodOption.macros?.kcal! | truncate }} kcal</span>
                  </div>

                  <div
                    class="d-flex flex-column justify-content-center align-items-center mx-1"
                  >
                    <span class="fw-bold">Proteínas</span>
                    <span>{{ foodOption.macros?.proteins! | truncate }}gr</span>
                  </div>
                </div>

                <div class="d-flex">
                  <div
                    class="d-flex flex-column justify-content-center align-items-center mx-1"
                  >
                    <span class="fw-bold">Carbohidratos</span>
                    <span
                      >{{
                        foodOption.macros?.carbohydrates! | truncate
                      }}
                      gr</span
                    >
                  </div>

                  <div
                    class="d-flex flex-column justify-content-center align-items-center mx-1"
                  >
                    <span class="fw-bold">Grasas</span>
                    <span>{{ foodOption.macros?.fats! | truncate }} gr</span>
                  </div>
                </div>

                <div class="d-flex" *ngIf="diet.status !== 'FINISHED'">
                  <div class="d-flex align-items-center">
                    <i
                      class="bi bi-pencil-square me-2"
                      style="font-size: 20px; cursor: pointer"
                      (click)="selectFoodOption(foodOption, $event)"
                    ></i>
                    <i
                      class="bi bi-trash me-2"
                      (click)="
                        deleteFoodOption(foodOption, foodOptionGroup, $event)
                      "
                      style="font-size: 24px; color: #dc3545; cursor: pointer"
                    ></i>
                  </div>
                </div>
              </div>

              <button
                class="food-option-create-btn my-2"
                *ngIf="diet.status !== 'FINISHED'"
                type="button"
                (click)="openFoodOptionModal(foodOptionGroup)"
              >
                Agregar Alternativa
              </button>
            </div>

            <button
              class="food-create-btn mt-3"
              (click)="openFoodOptionModal(undefined)"
              type="button"
              *ngIf="diet.status !== 'FINISHED'"
            >
              Agregar Alimento
            </button>
          </div>

          <div class="row w-100 mt-3 gx-2 d-flex align-items-center">
            <div class="col-7">
              <button
                [disabled]="mealForm.invalid"
                *ngIf="diet.status !== 'FINISHED'"
                class="w-100 btn-custom"
                aria-label="Close"
              >
                <span *ngIf="mealMode == 'editing'">Editar nombre comida</span>

                <span *ngIf="mealMode == 'creating'">Crear comida</span>
              </button>
            </div>
            <div class="col-5">
              <button
                class="btn btn-danger w-100"
                *ngIf="mealMode !== 'creating' && diet.status !== 'FINISHED'"
                (click)="deleteMeal()"
              >
                Eliminar {{ mealToEdit!.title }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<app-food-options-form-modal [meal]="mealToEdit!"></app-food-options-form-modal>

<app-diet-form-modal
  [diet]="diet"
  (dietCreated)="onDietCreate()"
></app-diet-form-modal>

<app-import-user-selector
  (modalHidden)="onDietCreate()"
></app-import-user-selector>

<app-diet-calendar></app-diet-calendar>
